/**
 * Static-replica provider for leveraged-fund swap-collateral holdings.
 *
 * The dane etf-website aggregates raw swap holdings from the live API. This
 * v0 replica has no live feed, so it returns no rows; the leveraged
 * holdings table renders its "Holdings unavailable." state.
 */

export interface LeveragedRow {
  name: string;
  typeLabel: string;
  weightPct: number;
  marketValue: number;
  highlight?: boolean;
}

export function useLeveragedHoldings(_ticker: string): {
  rows: LeveragedRow[] | null;
  asOf: string | null;
  loading: boolean;
} {
  return { rows: null, asOf: null, loading: false };
}
